import * as React from 'react';
import {
  BaSeBreakpointContext,
  BaSeButton,
  BaSeDialogContext,
  BaSeHeading5,
  BaSeShapeButton,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import {
  CardHeader,
  CardHeaderButtons,
  MainBody,
} from '../../components/new-relatorios/fluxo/relatorio-fluxo-lista-styled';
import { RelatorioDasn } from '../../components/new-relatorios/dasn/relatorio-dasn';
import { RelatorioMensalMei } from '../../components/new-relatorios/mensal-mei/relatorio-mensal-mei';
import { ShowButtonsAction } from '../../components/new-relatorios/head-buttons-action';
import { ModalShare } from '../../components/new-relatorios/modal-share';
import { useRelatorio } from '../../services/relatorio/RelatorioService';

const DEFAULT_COLOR_TEXT = BaSeTheme.colors.institucionais.cinzaSebrae20;

export const ShowMoney = ({ value, forceNegative }) => {
  const money = Sebrae.useMask(parseFloat(value ?? '0').toFixed(2), 'decimal');
  const negative = React.useMemo(
    () => (forceNegative || money.includes('-') ? '-' : ''),
    [money, forceNegative],
  );

  return (
    <div style={{ minWidth: 114, display: 'grid', justifyContent: 'end' }}>
      <BaSeSmall1 isBold color={DEFAULT_COLOR_TEXT}>
        {negative} R$ {money.replace('-', '')}
      </BaSeSmall1>
    </div>
  );
};

export const RelatoriosMei = ({
  dados,
  download,
  loadingDownload,
  tipo,
  paramsFilter,
  isPublic = false,
}) => {
  const { compartilharRelatorio } = useRelatorio();
  const { inTablet } = React.useContext(BaSeBreakpointContext);
  const { showModal } = React.useContext(BaSeDialogContext);

  const typeReportMei = React.useMemo(
    () => ({
      DASNMEI: 'Relatório DASN MEI',
      MENSALMEI: 'Relatório Mensal MEI',
    }),
    [],
  );

  const isDasnMei = React.useMemo(
    () => tipo === typeReportMei.DASNMEI,
    [tipo, typeReportMei],
  );

  const isMensalMei = React.useMemo(
    () => tipo === typeReportMei.MENSALMEI,
    [tipo, typeReportMei],
  );

  const print = React.useCallback(() => {
    window.print();
  }, []);

  const handleShowModal = React.useCallback(
    () =>
      showModal({
        title: 'Compartilhar',
        actions: [],
        size: 'large',
        content: ({ closeModal }) => (
          <ModalShare
            closeModal={closeModal}
            filters={paramsFilter}
            columnsSelected={[]}
            callback={compartilharRelatorio}
            tipoRelatorio={
              isDasnMei ? 'RELATORIO_DASN' : 'RELATORIO_MENSAL_MEI'
            }
          />
        ),
      }),
    [isDasnMei, paramsFilter, compartilharRelatorio, showModal],
  );

  return (
    <>
      <MainBody>
        <CardHeader>
          <BaSeHeading5 color={DEFAULT_COLOR_TEXT}>
            {isDasnMei && 'Relatorio consolidado para as DASN MEI'}
            {tipo === typeReportMei.MENSALMEI &&
              'Relatorio mensal das receitas brutas'}
          </BaSeHeading5>
          <CardHeaderButtons>
            {!isPublic && (
              <ShowButtonsAction
                download={download}
                loadingDownload={loadingDownload}
                print={print}
                isDisabled={false}
                showModal={handleShowModal}
              />
            )}

            {isPublic &&
              (inTablet ? (
                <BaSeButton
                  value="Imprimir"
                  leftIcon="print"
                  onClick={print}
                  type="secondary"
                />
              ) : (
                <BaSeShapeButton
                  shape="square"
                  nameIcon="print"
                  onClick={print}
                  type="secondary"
                />
              ))}
          </CardHeaderButtons>
        </CardHeader>
        {dados && (
          <>
            {isDasnMei && <RelatorioDasn dados={dados} />}
            {isMensalMei && <RelatorioMensalMei dados={dados} />}
          </>
        )}
      </MainBody>
    </>
  );
};
